<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
        btnTitle="Add New"
        :showBtn="false"
        :showAddNew="true"
        title="Reward Points"
        @onClickAddNewButton="openAddModal"
      />
    </div>

    <div class="my-2 px-2">
      <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
      >

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Customer </label>
          <AsyncSelect
            placeholder="Party Name, ID, Mobile No"
            :api-service="fetchContactProfiles"
            :reduce="(name) => name.id"
            v-model="contactProfileId"
            :additional-query="{type: 'customer'}"
            :format-label="formatPatientLabel"
          />
        </div>
      </DateQuerySetter>
    </div>
    <div class="col-12 px-2 mt-2">
      <ListTable
          :tableItems="rewardList"
          @onEdit="handleEdit"
          :isEdit="false"
      />
    </div>
    <div class="px-2"><Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/></div>
  </div>

    <div class="col-lg-8">
      <AddModal
        v-if="store.state.isModalOpenTwo"
        :rewardData="editRewardData"
        :rewardId="editRewardData.id || null"
        :rewardPointAcc="rewardPointAcc"
        @onSubmit="onClickGo"
      />
    </div>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter';
import { ref, inject, onMounted, computed  } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import TitleButton from '@/components/atom/TitleButton';
import Pagination from '@/components/atom/Pagination';
import handleContact from "@/services/modules/contact";
import ListTable from '@/components/atom/super-shop/reward-point/ListTable.vue';
import AddModal from '@/components/atom/super-shop/reward-point/Add.vue';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import { useAsyncDropdownHelper } from "@/services/utils/asyncDropdownHelper";
import handleInventory from "@/services/modules/inventory";
import handlePurchase from '@/services/modules/purchase'

const router = useRouter()
const store = useStore()
let offset = ref(20)
let contactProfileId = ref(null)
const route = useRoute()
const status = ref(null)
const rewardList = ref([]);
const editRewardData = ref({});
const rewardPointAcc = ref([]);
const statusList = [
  {id: 'added', text: 'Added'},
  {id: 'redeemed', text: 'Redeemed'},
  {id: 'expired', text: 'Expired'},
];

const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();
const { fetchRewardPointList, fetchRewardPointById } = handleInventory();
const { getAccountHeadBySlag } = handlePurchase();

const showSuccess = inject('showSuccess');
const showError = inject('showError');

const companyId = computed(() => {
  return route.params.companyId
})
const startDate = computed(() => {
  return route.query.start
})
const endDate = computed(() => {
  return route.query.end
})
const page = computed(() => {
  return route.query.page
})

const openAddModal = () => {
  store.state.isModalOpenTwo = true;
  editRewardData.value = {};
}

const getQuery = () => {
  let query = '?company_id=' + companyId.value;
  if(contactProfileId.value) query += '&contact_profile_id='+contactProfileId.value;
  if(status.value) query += '&status='+status.value;
  if(startDate.value) query += '&start_date='+startDate.value;
  if(endDate.value) query += '&end_date='+endDate.value;
  query += '&offset='+ offset.value;
  query += '&page='+ page.value;

  return query
}

const onClickGo = async() => {
  const query = getQuery();
  try{
    const res = await fetchRewardPointList(query);
    if(! res.status) {
      rewardList.value = [];
      setPagination({data: []});
      return;
    }
    rewardList.value = res.data.data;
    setPagination(res.data);
  } catch(err){
    console.log(err)
  }
};

function setPagination(data) {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await onClickGo()
};

const handleEdit = async (id) => {
  const companyQuery = `?company_id=${companyId.value}`;
  try {
      const res = await fetchRewardPointById(id, companyQuery);
      if(!res.status){
        showError(res.message);
        return;
      }
      editRewardData.value = res.data;
      store.state.isModalOpenTwo = true;
  } catch(err){
      console.error(err);
      showError("Error fetching reward point details");
  }
};

const getRewardPointAccounts = async () => {
  const query = `?company_id=${companyId.value}`

  try {
    const res = await getAccountHeadBySlag('reward_points', query);
    if(! res.status) {
      return;
    }
    rewardPointAcc.value = res.data;
  } catch (e) {
    console.log('Something went wrong');
  }
}

onMounted( async() => {
  await onClickGo()
  await getRewardPointAccounts();
});
</script>
